<template>
  <div v-if="loaded">
    <v-data-table
      :headers="headers"
      :items="sessions"
      :pagination.sync="pagination"
      :total-items="total"
      :rows-per-page-items="[10, 20, 30, 50]"
      @update:pagination="updatePagination"
    >
      <template
        slot="items"
        slot-scope="{ item }"
      >
        <td>
          <router-link
            class="black--text"
            :to="{ name: 'payments-controls-show', params: { id: item.id } }"
          >
            {{ item.reference }}
          </router-link>
        </td>
        <td>
          <v-avatar
            :title="sessionStatusStrLong(item.status)"
            :color="sessionStatusColor(item.status)"
            :size="32"
            class="black--text font-weight-medium"
          >
            {{ sessionStatusStr(item.status) }}
          </v-avatar>
        </td>
        <td>
          {{ formatDate(item.updated_at ? item.updated_at : item.created_at) }}
        </td>
        <td>
          <v-chip
            :color="sessionTypeColor(item.session_type)"
            class="lighten-3"
            small
          >
            {{ sessionTypeStr(item.session_type) }}
          </v-chip>
        </td>
        <td>
          {{ getSessionDate(item.dates) }}
        </td>
        <td>{{ item.topic && item.topic.name ? item.topic.name : "-" }}</td>
        <td>
          {{
            item.organization && item.organization.name
              ? item.organization.name
              : "-"
          }}
        </td>
        <td>{{ item.team && item.team.name ? item.team.name : "-" }}</td>
        <td>
          <div v-if="item.contact">
            {{ item.contact.firstname }} {{ item.contact.lastname }}
          </div>
        </td>
        <td>
          <template v-for="t in item.trainers">
            <div
              v-if="item.trainers"
              :key="'trainer_' + t.id"
            >
              {{ t.firstname[0] }}. {{ t.lastname }}
            </div>
          </template>
        </td>
        <td>
          <v-btn
            class="mx-0"
            icon
            :to="{
              name: 'payments-controls-show',
              params: { id: item.id },
            }"
          >
            <v-icon>mdi-check-decagram-outline</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DateMixin from "@/mixins/date";
import SessionsMixin from "@/mixins/sessions";
import GlobalMixin from "@/mixins/global";
import Consts from "@/consts";
import Sessions from "@/api/sessions";

export default {
  mixins: [SessionsMixin, DateMixin, GlobalMixin],
  props: {
    application: {
      type: Number,
      required: true,
    },
    team: {
      type: [String, Number],
      required: true,
    },
    dates: {
      type: Object,
      required: true,
    },
    topic: {
      type: Array,
      default: () => [],
    },
    includesToEvaluate: {
      type: Boolean,
      default: () => true,
    },
    includesControlled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      sessions: [],
      sessionTypes: [
        { value: 1, text: this.sessionTypeStr(1) },
        { value: 2, text: this.sessionTypeStr(2) },
        { value: 3, text: this.sessionTypeStr(3) },
        { value: 4, text: this.sessionTypeStr(4) },
        { value: 5, text: this.sessionTypeStr(5) },
        { value: 6, text: this.sessionTypeStr(6) },
        { value: 7, text: this.sessionTypeStr(7) },
        { value: 8, text: this.sessionTypeStr(8) },
        { value: 9, text: this.sessionTypeStr(9) },
        { value: 10, text: this.sessionTypeStr(10) },
      ],
      headers: [
        { text: "#", value: "", sortable: false, width: 70 },
        { text: "Status", value: "status", width: 80 },
        { text: "Last update", value: "updated_at", width: 100 },
        { text: "Type", value: "session_type", width: 100 },
        { text: "Date(s)", value: "sd.start" },
        { text: "Concept", value: "topic.name" },
        { text: "Organization", value: "org.name" },
        { text: "Team", value: "team.name" },
        { text: "Contact(s)", value: "c.firstname" },
        { text: "Trainer(s) / AS", value: "trainer.lastname" },
      ],
      total: 0,
      pagination: {
        sortBy: "sd.start",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      lastPagination: null,
      Consts,
      loaded: false,
    };
  },
  mounted() {
    const storedPagination = this.getStoredObject("controls.pagination");
    if (storedPagination) {
      this.pagination = storedPagination;
    }
    this.fetch();
  },
  methods: {
    async fetch(from = "local") {
      if (from == "filters") {
        this.pagination.page = 1;
      }
      const team_id = this.team != 0 ? [this.team] : [];
      const status = this.includesToEvaluate
        ? [Consts.TOEVALUATE, Consts.TOCONTROL]
        : [Consts.TOCONTROL];
      const params = Object.assign({}, this.pagination, {
        application: this.application,
        team_id,
        status,
        start: this.dates.start,
        end: this.dates.end,
        topic_id: this.topic,
        includes_controlled: this.includesControlled,
        scope: "indemnities",
      });
      const { data } = await Sessions.getList(params);
      this.sessions = data.items;
      this.pagination.totalItems = data.total;
      this.total = data.total;
      if (from == "filters") {
        this.updatePagination(this.pagination, false);
      }
      this.loaded = true;
    },
    getSessionDate(s) {
      let out = "";

      if (s.length === 0) {
        out += "-";
      } else if (s.length >= 1) {
        const d = s[0];
        out +=
          this.formatDate(d.start) +
          " [" +
          this.formatTime(d.start) +
          " - " +
          this.formatTime(d.end) +
          "]";
      }

      if (s.length > 1) {
        out += " (+" + (s.length - 1) + " other)";
      }

      return out;
    },
    updatePagination(pagination, fetch = true) {
      //Très très très galère pour ne pas avoir 50 appels à l'API
      if (
        this.lastPagination &&
        JSON.stringify(pagination) !== JSON.stringify(this.lastPagination)
      ) {
        this.lastPagination = { ...pagination };
        this.setStoredObject("controls.pagination", pagination);
        if (fetch) {
          this.fetch();
        }
      }
      if (!this.lastPagination) {
        this.lastPagination = { ...pagination };
      }
    },
  },
};
</script>

<style scoped lang="sass"></style>
